import React, { useState, lazy, Suspense, memo, useContext} from 'react';
import { SttTabs, SttTranslateHook } from '@stt-componentes/core-v2';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    wrapper: {
        padding: theme.spacing(1)
    }
}));

const VisaoGeral = lazy(() => import('./visao-geral/VisaoGeral'));

const VisaoGeralSuspense = memo((props) => {
   return (
       <Suspense>
           <VisaoGeral {...props} />
       </Suspense>
   );
});

const IndexVisaoGeral = ({ props }) => {

    const { strings } = useContext(SttTranslateHook.I18nContext);
    const classes = useStyles();

    const abas = [
        {
            titulo: strings.visaoGeral,
            conteudo: VisaoGeralSuspense,
            key: 'VisaoGeralSuspense',
            permanente: true,
        }
    ];


    const [abaAtiva, setAbaAtiva] = useState('0');

    return (
        <SttTabs
            abas={abas}
            className={classes.wrapper}
            canClose={true}
            handleChangeAbaAtiva={setAbaAtiva}
            abaAtiva={abaAtiva}
            permanente={true}
            preload={false}
        />
    );
};

export default IndexVisaoGeral;
